import React from "react";
import { LayersControl, TileLayer } from 'react-leaflet';
import "./leafletlayers.css";

const MAPBOX_API_KEY = process.env.REACT_APP_MAPBOX_API_KEY || "pk.eyJ1IjoibWFjY2hlc3RlcjkyIiwiYSI6ImNrZnJ5N2QxaDE1eHEyeXBhOTUxYzg5c3YifQ.24K_L4FatEYK_uyyzyjWuQ";
const OPEN_CYCLE_MAP_API_KEY = process.env.REACT_APP_OPEN_CYCLE_MAP_API_KEY || "unknown";
const cacheMaxAge = 30 * 24 * 60 * 60 * 1000;


const LeafletLayers = () => {

  return (
    <>
    <LayersControl position="topright">
      <LayersControl.BaseLayer checked name="Open Street Map">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={20}
          maxNativeZoom={18}
          />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Swiss Topo">
        <TileLayer name="Swiss Topo"
          url="https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg"
          maxZoom={20}
          maxNativeZoom={18}
          layer='ch.swisstopo.swisstlm3d-wanderwege'
          /> 
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="mapBox Streets">
        <TileLayer name="mapBox Streets"
          url="https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token={accessToken}"
          attribution='© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>'
          id="mapbox/streets-v11"
          maxZoom={20}
          titleSize={512}
          accessToken={MAPBOX_API_KEY}
          useCache={true}
          crossOrigin={true}
          cacheMaxAge={cacheMaxAge}
          /> 
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="mapBox Outdoors">
        <TileLayer name="mapBox Outdoors"
          url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}"
          attribution='© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>'
          id="mapbox/outdoors-v12"
          maxZoom={20}
          titleSize={512}
          accessToken={MAPBOX_API_KEY}
          useCache={true}
          crossOrigin={true}
          cacheMaxAge={cacheMaxAge}
          /> 
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="openCycleMap">
        <TileLayer name="openCycleMap"
          url="https://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey={apikey}"
          attribution='&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          maxZoom={20}
          maxNativeZoom={18}
          zoomOffset={-1}
          apikey={OPEN_CYCLE_MAP_API_KEY}
          useCache={true}
          crossOrigin={true}
          cacheMaxAge={cacheMaxAge}
          /> 
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="openHikingMap">
        <TileLayer name="openHikingMap"
          url="https://maps.refuges.info/hiking/{z}/{x}/{y}.png"
          attribution='<a href="https://wiki.openstreetmap.org/wiki/Hiking/mri">MRI</a> | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          maxZoom={20}
          maxNativeZoom={18}
          /> 
      </LayersControl.BaseLayer>
      <LayersControl.Overlay name="mapBox Satellite">
        <TileLayer name="mapBox Satellite"
          url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}"
          maxZoom={20}
          maxNativeZoom={18}
          id="mapbox/satellite-v9"
          titleSize={512}
          accessToken={MAPBOX_API_KEY}
          opacity={0.8}
          useCache={true}
          crossOrigin={true}
          cacheMaxAge={cacheMaxAge}
          /> 
      </LayersControl.Overlay>
    </LayersControl>
    </>
  );
};

export default LeafletLayers;